/**
 * @generated SignedSource<<d5e84f33868087872a0bcb4905959c41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type deactivateRuleMutation$variables = {
  ruleName: string;
};
export type deactivateRuleMutation$data = {
  readonly deactivateRule: {
    readonly name: string;
    readonly namespace: string;
    readonly owner: string;
  } | null;
};
export type deactivateRuleMutation = {
  response: deactivateRuleMutation$data;
  variables: deactivateRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ruleName"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ruleName",
        "variableName": "ruleName"
      }
    ],
    "concreteType": "RuleSummary",
    "kind": "LinkedField",
    "name": "deactivateRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "namespace",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "owner",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deactivateRuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deactivateRuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "63a7bd5bfedbdeb1e532ce68b1a5cc8c",
    "id": null,
    "metadata": {},
    "name": "deactivateRuleMutation",
    "operationKind": "mutation",
    "text": "mutation deactivateRuleMutation(\n  $ruleName: String!\n) {\n  deactivateRule(ruleName: $ruleName) {\n    name\n    namespace\n    owner\n  }\n}\n"
  }
};
})();

(node as any).hash = "45f50a0099a552f30b020825d65428fb";

export default node;
